import { Link } from "react-router-dom";
import { Seo, breadcrumbSchema } from "@/components/layout/Seo";
import { PageHero } from "@/components/ui/motion";

const PRIVACY = [
  ["Data yang kami kumpulkan", ["Melalui formulir konsultasi, kami mengumpulkan nama lengkap, nomor WhatsApp, email (opsional), jenis kewajiban, perkiraan total kewajiban, dan pesan tambahan yang Anda berikan secara sukarela.", "Kami tidak pernah meminta PIN, CVV, OTP, password, atau kredensial perbankan dalam bentuk apa pun."]],
  ["Tujuan penggunaan", ["Data digunakan untuk menghubungi Anda, memahami kondisi kewajiban, dan memberikan konsultasi serta pendampingan sesuai permintaan Anda."]],
  ["Penyimpanan dan keamanan", ["Data disimpan pada sistem dengan akses terbatas dan hanya dapat diakses oleh tim yang berkepentingan untuk keperluan layanan."]],
  ["Pembagian data", ["Kami tidak menjual atau menyewakan data pribadi Anda. Data hanya dibagikan kepada pihak terkait apabila diperlukan untuk proses pendampingan dan atas persetujuan Anda, atau bila diwajibkan oleh peraturan perundang-undangan."]],
  ["Hak Anda", ["Anda dapat meminta akses, perbaikan, atau penghapusan data pribadi Anda dengan menghubungi kami melalui kanal resmi."]],
  ["Perubahan kebijakan", ["Kebijakan ini dapat diperbarui sewaktu-waktu. Versi terbaru selalu tersedia di halaman ini."]],
];

const TERMS = [
  ["Ruang lingkup layanan", ["Mika Solution menyediakan konsultasi dan pendampingan penyelesaian kewajiban finansial. Ruang lingkup pendampingan untuk setiap klien ditetapkan dalam kesepakatan tertulis."]],
  ["Tidak ada jaminan hasil", ["Hasil penyelesaian bergantung pada kondisi akun, kebijakan kreditur atau penyedia pinjaman, dan persetujuan pihak terkait. Kami tidak menjamin potongan, cicilan tertentu, penghapusan kewajiban, maupun perubahan catatan SLIK."]],
  ["Biaya layanan", ["Konsultasi awal tidak dikenakan biaya. Biaya pendampingan dijelaskan dan disepakati secara tertulis sebelum pendampingan dimulai."]],
  ["Kewajiban klien", ["Klien bertanggung jawab memberikan informasi yang benar dan lengkap, serta melakukan pembayaran kewajiban hanya melalui rekening resmi kreditur."]],
  ["Informasi di situs", ["Konten di situs ini bersifat edukasi umum dan bukan nasihat hukum atau keuangan untuk kondisi tertentu."]],
  ["Perubahan ketentuan", ["Ketentuan ini dapat diperbarui sewaktu-waktu. Versi terbaru selalu tersedia di halaman ini."]],
];

const LegalPage = ({ title, path, lines, sections, desc }) => {
  const crumbs = [{ to: "/", label: "Beranda" }, { to: path, label: title }];
  return (
    <>
      <Seo title={`${title} | Mika Solution`} description={desc} path={path} schema={[breadcrumbSchema(crumbs)]} />
      <PageHero crumbs={crumbs} eyebrow="Legal" lines={lines} desc={desc} />
      <section className="py-16 sm:py-24" data-testid="legal-content">
        <div className="wrap prose-mika max-w-3xl">
          {sections.map(([h, ps], i) => (
            <section key={h}>
              <h2>{String(i + 1).padStart(2, "0")}. {h}</h2>
              {ps.map((p) => <p key={p.slice(0, 20)}>{p}</p>)}
            </section>
          ))}
          <p className="!mt-12 text-[14px] text-ink-soft">Pertanyaan terkait halaman ini dapat disampaikan melalui <Link to="/kontak" className="text-accentb underline underline-offset-4">halaman kontak</Link>.</p>
        </div>
      </section>
    </>
  );
};

export const Privacy = () => (
  <LegalPage title="Kebijakan Privasi" path="/kebijakan-privasi" lines={["Kebijakan", <span className="serif-it font-normal text-accentb">Privasi.</span>]} sections={PRIVACY} desc="Cara Mika Solution mengumpulkan, menggunakan, dan melindungi data pribadi Anda." />
);

export const Terms = () => (
  <LegalPage title="Syarat & Ketentuan" path="/syarat-ketentuan" lines={["Syarat &", <span className="serif-it font-normal text-accentb">Ketentuan.</span>]} sections={TERMS} desc="Ketentuan penggunaan situs dan layanan konsultasi Mika Solution." />
);
